// extracted by mini-css-extract-plugin
export default {"animated":"IntegrationSyncIcon-module__animated____wnQX","spin":"IntegrationSyncIcon-module__spin___b2ndW"};